import React from 'react';
import Home from 'app/screens/Home';
import ReviewOrder from 'app/screens/ReviewOrder';
import StrollerList from 'app/screens/StrollerList';
import Accessories from 'app/screens/Accessories';
import Checkout from 'app/screens/Checkout';
import ThankYou from 'app/screens/ThankYou';
import ContactUs from 'app/screens/ContactUs';
import AboutUs from 'app/screens/AboutUs';
import Faqs from 'app/screens/Faqs';
import RentalAgreement from 'app/screens/RentalAgreement';
import Testimonials from 'app/screens/Testimonials';
import Redirector from 'app/screens/Redirector';
import Login from 'app/screens/EditOrder/Login';
import EditOrder from 'app/screens/EditOrder/EditOrder';
import EditTime from 'app/screens/EditOrder/EditTime';

export interface Routes {
  name: string;
  route: string;
  component: React.FC;
  props?: Record<string, unknown>;
  needsCart?: boolean;
  needsEditOrderData?: boolean;
  needsThankYouProducts?: boolean;
}

const routes: Array<Routes> = [
  {
    name: 'Home',
    route: '/',
    component: Home,
  },
  {
    name: 'Review Order',
    route: '/review',
    component: ReviewOrder,
    needsCart: true,
  },
  {
    name: 'Stroller List',
    route: '/stroller-list',
    component: StrollerList,
  },
  {
    name: 'Accessories',
    route: '/accessories',
    component: Accessories,
    needsCart: true,
  },
  {
    name: 'Checkout',
    route: '/checkout',
    component: Checkout,
    needsCart: true,
  },
  {
    name: 'ThankYou',
    route: '/thank-you',
    component: ThankYou,
    needsThankYouProducts: true,
  },
  {
    name: 'About Us',
    route: '/about-us',
    component: AboutUs,
  },
  {
    name: 'FAQs',
    route: '/faqs',
    component: Faqs,
  },
  {
    name: 'Rental Agreement',
    route: '/rental-agreement',
    component: RentalAgreement,
  },
  {
    name: 'Contact Us',
    route: '/contact-us',
    component: ContactUs,
  },
  {
    name: 'Testimonials',
    route: '/testimonials',
    component: Testimonials,
  },
  // Edit Order
  {
    name: 'Login',
    route: '/edit-order/login',
    component: Login,
  },
  {
    name: 'Edit Time',
    route: '/edit-order/edit-time',
    component: EditTime,
    needsEditOrderData: true,
  },
  {
    name: 'Edit Order Checkout',
    route: '/edit-order/checkout',
    component: Checkout,
    needsEditOrderData: true,
  },
  {
    name: 'Edit Order ThankYou',
    route: '/edit-order/thank-you',
    component: ThankYou,
    needsThankYouProducts: true,
  },
  {
    name: 'Edit Order',
    route: '/edit-order/:orderId',
    component: EditOrder,
    needsEditOrderData: true,
  },
  // Redirector
  {
    name: 'Wildcard',
    route: '*',
    component: Redirector,
  },
];

export default routes;
